import React, { Component } from "react";
import { connect } from "react-redux";
import ComponentHeader from "../common/ComponentHeader";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button, Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import editPencil from "../../assets/images/edit-icon.png";
import { getAllEventDataApi } from "./Api";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import { InformationModal, Spinner, VerifiedModal } from "../common";
import moment from "moment";
import { deleteAuthCommonApi } from "../content/Api";
import { toast } from "react-toastify";
import { EVENT_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { showLoader } from "../../utils/ReusableFunctions";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

class Events extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.EventEvent);

    this.state = {
      access: AccesData,
      search: "",
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''

    };
  }


  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllEventDataApi(this);

  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSearch = prevParams.get("search") || "";
    const prevSize = prevParams.get("pageSize") || "";


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const search = params.get("search") || "";
    const size = params.get("pageSize") || "";



    if (prevPage !== page || prevVerified !== verified || prevSearch !== search) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllEventDataApi(this);

      });
    }
  }

  getDetailsUser = (data) => {
    this.props.history({ pathname: `/events/details/${data?.uuid}`, state: { "id": data?.uuid } });
  }
  showEditModal = (rowData = null) => {
    this.props.history({ pathname: `/events/add-event`, state: { data: rowData } })
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };

  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/events/${id}`);

    if (res.status === 200) {
      this.props.getAllEventDataApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }
  render() {
    const { search, dummyData, access } = this.state;

    const { eventData, totalPages, currentPage } = this.props.eventsState;

    return (
      <>
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.name}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.name}'`}
          show={this.state.show}
          url={EVENT_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllEventDataApi(this) }}
        />
        <section>
          <ComponentHeader
            title="Events"
            primaryBtn={access.createAccess ? "Add Event" : ""}
            breadcrumb={[["Events", "/events"]]}
            handlePrimaryBtn={() => { this.props.history('/events/add-event') }}
            ctx={this}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
            ctx={this}
              data={eventData?.list}
              columns={[
                {
                  width: 200,
                  title: "Name",
                  dataIndex: "name",
                  className: "name",
                  
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.name;
                  },
                },
                {
                  width: access.verificationAccess ? 100 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },

                {
                  width: 200,
                  title: "Event Format",
                  dataIndex: "eventFormat",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.eventFormat;
                  },
                },

                {
                  width: 200,
                  title: "Event Date",
                  dataIndex: "date",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return moment(rowData?.startDate).format('lll');
                  },
                },

                {
                  width: 150,
                  title: "Updated By",
                  dataIndex: "updatedBy",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.updatedBy?.name || 'Na';;
                  },
                },
                {
                  width: 150,
                  title: "Created By",
                  dataIndex: "createdBy",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.createdBy?.name || 'Na';
                  },
                },
                {

                  width: 20,
                  title: "Action",
                  dataIndex: "",
                  fixed: 'right',
                  className: "",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (
                        // <div className="d-flex gap-4 justify-content-around">
                        //   <Button onClick={() => this.getDetailsUser(rowData)} className="primary-btn">
                        //     View
                        //   </Button>
                        //   {access.updateAccess && (
                        //     <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                        //   )}
                        //   {access.deleteAccess && (
                        //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                        //   )}
                        // </div>
                        <OptionsDropdown
                          editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                          deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                          viewHandler={() => this.getDetailsUser(rowData)}
                        />
                      );
                    }
                  },


              ]}
              total={eventData?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  eventsState: state.EventsState,
});
const mapDispatchToProps = {
  getAllEventDataApi
};
Events.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Events));
